import { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

export const Section = ({
  title,
  subtitle,
  children,
  className,
}: PropsWithChildren<{
  title: string;
  subtitle?: string;
  className?: string;
}>) => {
  return (
    <div className={cn('flex flex-col gap-y-10', className)}>
      <div className="text-center">
        <h2 className="text-2xl font-medium tracking-tight text-foreground sm:text-3xl">{title}</h2>
        {subtitle && <p className="mx-auto mt-2 max-w-2xl text-muted-foreground">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
};
